import React from 'react';
import styled from 'styled-components';

interface EmailIdColumnFormatterProps {
  emailId: string;
}

const EmailIdColumnFormatterContainer = styled.div``;
const EmailIdColumnFormatter: React.FC<EmailIdColumnFormatterProps> = ({
  emailId,
}) => {
  const email = emailId?.split('@')[0];
  if (!email) {
    return null;
  }
  return (
    <EmailIdColumnFormatterContainer>{email}</EmailIdColumnFormatterContainer>
  );
};

export default EmailIdColumnFormatter;
